
export function vgca_check_plugin(success, fail, json_prms) {
    if ("WebSocket" in window) {
        var socket = new WebSocket("wss://127.0.0.1:8987/SignApproved");
        socket["onopen"] = function () {
            success(json_prms);
        };

        socket.onerror = function () {
            fail();
        };

        socket.onclose = function () { };
    }
}